import React from 'react';

import { classesData } from 'data/javascript/classes';

import DescriptionEntry from 'components/shared/description-entry';

const JavaScriptClasses = () => {
  const item = classesData?.items.find((item) => item.title === 'Classes');

  return <DescriptionEntry entry={item} />;
};

export default JavaScriptClasses;
